/**
 * Fills a Uint8Array with cryptographically secure random values using Web Crypto API.
 *
 * This implementation is intended for modern browsers where `crypto.getRandomValues`
 * is available. It throws if the API is not supported (which would indicate a very old environment).
 *
 * @param target - The Uint8Array to be filled with random bytes
 */
export function randomFill(target: Uint8Array) {
  globalThis.crypto.getRandomValues(target);
}